<template>
  <div>
  <a-form-model ref="form" :model="form.data" :rules="form.rules">
    <a-form-model-item label="类型" prop="type">
      <dict-select v-model="form.data.type" dict-code="INDEX_POSTER_TYPE"/>
    </a-form-model-item>
    <a-form-model-item label="图片(668*835)" v-if="form.data.type==='IMAGE'">
      <div class="a-input">
        <simple-uploader-s3 v-model="form.data.inspirationImg"/>
      </div>
    </a-form-model-item>
    <a-form-model-item label="视频封面(668*835)" prop='videoCover' v-if="form.data.type==='VIDEO'">
      <div class="a-input">
        <simple-uploader-s3 v-model="form.data.videoCover"/>
      </div>
    </a-form-model-item>
    <a-form-model-item label="视频" v-if="form.data.type==='VIDEO'">
      <span class="help-tip" slot="extra" style="cursor: pointer" @click="reviewVideo">{{$t('PREVIEW') || '预览' }}</span>
      <div class="a-input">
    <!--                      <multi-uploader v-model="form.data.inspirationVideo"/>-->
        <simple-uploader-s3 v-model="form.data.inspirationVideo" :type="form.data.type"/>
      </div>
    </a-form-model-item>
    <a-form-model-item>
      <a-space>
        <a-button type="primary" v-if="!inspirationId" @click="onAdd">创建</a-button>
        <a-button type="primary" v-if="inspirationId" @click="onUpdate">更新</a-button>
        <a-button @click="onCancel">{{ $t('CANCEL') || '取消' }}</a-button>
      </a-space>
    </a-form-model-item>
  </a-form-model>
  <a-modal
    :footer="null"
    append-to-body
    title="视频预览"
    v-model="video.visible">
    <video
      v-if="video.visible"
      ref="video"
      webkit-playsinline="true"
      playsinline="true"
      x-webkit-airplay="true"
      x5-video-player-type="h5"
      x5-video-player-fullscreen="ture"
      x5-video-orientation="portraint"
      style="width: 100%;height: auto"
      autoplay
      preload="auto"
      muted="true"
      :src="form.data.inspirationVideo">
      您的浏览器不支持 HTML5
    </video>
  </a-modal>
  </div>
</template>

<script>
import {
  _queryInspiration,
  _addInspiration,
  _updateInspiration,
} from '@/api/goodsSeriesInspirationApi';
import SimpleUploader from '@/components/SimpleUploader.vue';
// import MultiUploader from '../../../components/MultiUploader.vue';
import DictSelect from '../../../components/DictSelect.vue';
import SimpleUploaderS3 from '@/components/SimpleUploaderS3.vue';

async function getInspiration() {
  const result = await _queryInspiration(this.inspirationId);
  if (result) {
    this.form.data.type = result.type;
    this.form.data.inspirationImg = result.inspirationImg;
    this.form.data.inspirationVideo = result.inspirationVideo;
    this.form.data.videoCover = result.videoCover;
  }
}

async function onAdd() {
  console.log(this.seriesId);
  this.$refs.form.validate(async (valid) => {
    if (valid) {
      const result = await _addInspiration({
        type: this.form.data.type,
        inspirationImg: this.form.data.inspirationImg,
        inspirationVideo: this.form.data.inspirationVideo,
        videoCover: this.form.data.videoCover,
        seriesId: this.seriesId,
      });
      if (result) {
        if (this.onSubmitHandler) {
          this.$message.success('添加成功');
          this.onSubmitHandler();
        }
      }
    }
  });
}
function reviewVideo() {
  if (this.form.data.inspirationVideo) {
    this.video.visible = true;
  }
}

async function onUpdate() {
  this.$refs.form.validate(async (valid) => {
    if (valid) {
      const result = await _updateInspiration(this.inspirationId, {
        type: this.form.data.type,
        inspirationImg: this.form.data.inspirationImg,
        inspirationVideo: this.form.data.inspirationVideo,
        videoCover: this.form.data.videoCover,
        seriesId: this.seriesId,
      });
      if (result) {
        if (this.onSubmitHandler) {
          this.$message.success('更新成功');
          this.onSubmitHandler();
        }
      }
    }
  });
}

function onCancel() {
  if (this.onCancelHandler) {
    this.onCancelHandler();
  }
}

export default {
  name: 'GoodsSeriesInspirationEdit',
  components: {
    SimpleUploaderS3,
    // MultiUploader,
    DictSelect,
  },
  props: {
    inspirationId: String,
    seriesId: String,
    onSubmitHandler: Function,
    onCancelHandler: Function,
  },
  watch: {
    inspirationId() {
      if (this.inspirationId) {
        this.getInspiration();
      }
    },
  },
  methods: {
    onAdd,
    onUpdate,
    onCancel,
    getInspiration,
    reviewVideo,
  },
  data() {
    return {
      video: {
        visible: false,
        url: '',
      },
      form: {
        data: {
          type: 'IMAGE',
          inspirationImg: '',
          inspirationVideo: '',
          videoCover: '',
        },
        rules: {
          // name: [{ required: true, trigger: 'blur' }],
          // nameEn: [{ required: true, trigger: 'blur' }],
          // coverPath: [{ required: true, trigger: 'blur' }],
          // isVip: [{ required: true, trigger: 'blur' }],
        },
        title: '',
      },
    };
  },
  created() {
    if (this.inspirationId) {
      this.getInspiration();
    }
  },
};
</script>
